import { s as subscribe } from "../../../../../chunks/utils.js";
import { c as create_ssr_component, v as validate_component, d as add_attribute, e as escape } from "../../../../../chunks/ssr.js";
import "../../../../../chunks/customer2.js";
import { p as page } from "../../../../../chunks/stores.js";
import { A as Alert } from "../../../../../chunks/Alert.js";
/* empty css                                                          */
import "../../../../../chunks/files.js";
import "../../../../../chunks/client.js";
import "../../../../../chunks/api.js";
import { C as CardLayout } from "../../../../../chunks/CardLayout.js";
import { I as InfoBox } from "../../../../../chunks/InfoBox.js";
import { C as CardLayoutSubmitButton } from "../../../../../chunks/CardLayoutSubmitButton.js";
const ClientContactCard = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let address;
  let { customer } = $$props;
  let countries = [];
  if ($$props.customer === void 0 && $$bindings.customer && customer !== void 0) $$bindings.customer(customer);
  address = customer.address;
  return `${validate_component(CardLayout, "CardLayout").$$render($$result, { title: "Kontakt" }, {}, {
    default: () => {
      return `<form class="flex flex-col gap-3" method="post" action="?/saveClientAddress"><input type="hidden" name="customerUuid"${add_attribute("value", customer.uuid, 0)}> <input type="hidden" name="uuid"${add_attribute("value", address.uuid, 0)}> <div class="flex gap-2">${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          placeholder: "Strasse",
          value: address.street,
          name: "street"
        },
        {},
        {}
      )} ${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          placeholder: "Hausnummer",
          value: address.number,
          name: "number"
        },
        {},
        {}
      )}</div> <div class="flex gap-2">${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          placeholder: "Ort",
          value: address.place,
          name: "place"
        },
        {},
        {}
      )} ${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          placeholder: "PLZ",
          value: address.zip,
          name: "zip"
        },
        {},
        {}
      )}</div> ${validate_component(InfoBox, "InfoBox").$$render(
        $$result,
        {
          type: "select",
          items: countries,
          value: address.country,
          name: "country"
        },
        {},
        {}
      )} ${validate_component(CardLayoutSubmitButton, "CardLayoutSubmitButton").$$render($$result, {}, {}, {})}</form>`;
    }
  })}`;
});
const Page = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let customer;
  let $page, $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  let $$settled;
  let $$rendered;
  let previous_head = $$result.head;
  do {
    $$settled = true;
    $$result.head = previous_head;
    customer = $page.data.customer;
    $$rendered = `${$$result.head += `<!-- HEAD_svelte-kmo8n4_START -->${$$result.title = `<title>${escape(customer.name)} </title>`, ""}<!-- HEAD_svelte-kmo8n4_END -->`, ""} <div class="flex flex-col lg:flex-row gap-3"><div class="flex flex-col gap-7 xl:max-w-sm">${validate_component(ClientContactCard, "ClientContactCard").$$render(
      $$result,
      { customer },
      {
        customer: ($$value) => {
          customer = $$value;
          $$settled = false;
        }
      },
      {}
    )}</div> <div class="flex flex-col 2xl:flex-row gap-3 w-full"><div class="flex flex-col w-full gap-7">${validate_component(CardLayout, "CardLayout").$$render($$result, { title: "Reminder" }, {}, {})} ${validate_component(CardLayout, "CardLayout").$$render($$result, { title: "Headquarter Anschrift" }, {}, {
      default: () => {
        return `<p data-svelte-h="svelte-y2xia7">Rechnungsanschrift: wie TC</p> <p data-svelte-h="svelte-hv3urm">Sortabletable: Ansprechpartner</p>`;
      }
    })} ${validate_component(CardLayout, "CardLayout").$$render($$result, { title: "Niederlassung Y - woanders" }, {}, {
      default: () => {
        return `<p data-svelte-h="svelte-dant23">&quot;Lieferanschrift&quot;</p> <p data-svelte-h="svelte-lktbzn">Rechnungsanschrift (inherit)</p> <p data-svelte-h="svelte-8eu8t7">invoice email-Addresse</p> <p data-svelte-h="svelte-hv3urm">Sortabletable: Ansprechpartner</p>`;
      }
    })}</div> <div class="max-w-sm w-full">TL
            ${validate_component(Alert, "Alert").$$render($$result, { color: "red", dismissable: true }, {}, {
      default: () => {
        return `Consortium 286`;
      }
    })}</div></div></div> `;
  } while (!$$settled);
  $$unsubscribe_page();
  return $$rendered;
});
export {
  Page as default
};
//# sourceMappingURL=_page.svelte.js.map
